<template lang="pug">
    model-data-table(
        loading-text="Cargando vendedores..."
        no-data-text="Sin vendedores."
        ref="table"
        remind-key='g-user-list'
        v-bind="tableProps"
        @detail="submitTableShow"
        @remove="submitTableRemove"
        :no-remove="!$can('DELETE_USER')"
        )
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
//
import { ModelDataTable } from '@/components/reusable_components/next'
import UserSellerService from '@/services/api/userSeller'
//-
import MdlUserSeller from '../../models/General/GUserSeller'
import UserFilters from './partials/filters'
import UserHeaders from './partials/headers'
//
export default {
    name: 'users-list',
    components: {
        'model-data-table': ModelDataTable,
    },
    data() {
        return {
            filters: UserFilters,
            headers: UserHeaders,
            // service: UserSellerService,
            selectedItemId: null,
        }
    },
    computed: {
        /**
         *
         */
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),

        /**
         *
         */
        tableProps() {
            return {
                filters: this.filters,
                headers: this.headers,
                service: MdlUserSeller,
            }
        },
    },
    methods: {
        /**
         *
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),

        /**
         *
         */
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),

        /**
         *
         */
        refresh: function() {
            this.$refs.table.refresh()
        },

        /**
         *
         */
        async removeSelectedItem() {
            //
            const response = await UserSellerService.remove(this.selectedItemId)
            //
            switch (response.status) {
                case 'success':
                    this.resetSnackbarState()
                    this.showSnackbar(
                        'success',
                        'Vendedor Eliminado.',
                        null,
                        this.refresh
                    )
                    break
                case 'error':
                    this.resetSnackbarState()
                    this.showSnackbar('warning', 'Error.', response.error)
                    break
            }
        },

        /**
         *
         */
        async showSnackbar(type, title, message, callback = () => {}) {
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))
            callback()
        },

        /**
         *
         */
        submitTableRemove(event) {
            //
            this.resetSnackbarState()
            this.setMessageConfirmSnack('ELIMINAR')
            this.showSnackbar(
                'warning',
                'Advertencia',
                '¿Deseas eliminar a vendedor?'
            )
            //
            this.selectedItemId = event.item.id
        },

        /**
         *
         */
        submitTableShow(event) {
            this.$router.push({
                name: 'users_show',
                params: { id: event.item.id },
            })
        },
    },
    beforeMount() {
        this.setTitleTopBar('Listado de vendedores')
        this.$setItemsTopBar([
            {
                text: 'crear vendedor',
                icon: 'add',
                can: 'CREATE_SELLER',
                action: () => this.$router.push('/users/create'),
            },
        ])
    },
    watch: {
        /**
         *
         */
        async responseConfirm(message) {
            switch (message) {
                case 'ELIMINAR':
                    return this.removeSelectedItem()
            }
        },
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_ALL_SELLER')) ctx.$router.push('/')
        })
    },
}
</script>
